import React, { useState, useRef } from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
const center = {
  lat: 0,
  lng: -10,
};
const position = {
  lat: 37.772,
  lng: -122.214,
};
const mapContainerStyle = {
  width: "100%",
  height: "100%",
};

const CustomGoogleMap = ({ locations, setMapCenter }) => {
  const mapRef = useRef(null);
  const [markerCoords, setMarkerCoords] = useState();
  const [markerData, setMarkerData] = useState();

  function handleLoad(map) {
    mapRef.current = map;
  }

  // function handleCenter() {
  //   if (!mapRef.current) return;

  //   const { lat, lng } = mapRef.current.getCenter().toJSON();
  //   if (lat !== center.lat || lng !== center.lng) {
  //     setMapCenter({ lat, lng });
  //   }
  // }

  return (
    <LoadScript googleMapsApiKey="AIzaSyA-smXvrvI1um7eerwS0mAN6J9tULBWQ3M">
      <GoogleMap
        onLoad={handleLoad}
        mapContainerStyle={mapContainerStyle}
        center={center}
        zoom={1.8}
        // onCenterChanged={handleCenter}
        // onZoomChanged={handleCenter}
        mapTypeId="satellite"
        // mapOptions={{
        //   styles: [{
        //     featureType: "road.local",
        //     elementType: "labels"
        //   }]
        // }}
      >
        {locations.map((loc) => (
          <Marker
            position={{
              lat: loc.coords[0],
              lng: loc.coords[1],
            }}
            label={{
              text: loc.languageName,
              color: "yellow",
              backgroundColor: "red",
            }}
            title={loc.languageName}
          />
        ))}
      </GoogleMap>
    </LoadScript>
  );
};

export default CustomGoogleMap;
